// Dependencies
import React, { createClass, PropTypes } from 'react';
import ConnectionsTagsTypeAhead from './typeahead';
import ClickAwayListener from 'material-ui/internal/ClickAwayListener';


const ConnectionsTypeAhead = createClass({

  propTypes: {
    open: PropTypes.bool,
    toggleTypeAhead: PropTypes.func,
    allUserTags: PropTypes.object,
  },

  componentClickAway(){
    if (this.props.open) this.props.toggleTypeAhead();
  },

  render(){
    return (
      <ClickAwayListener onClickAway={this.componentClickAway}>
        <div className="type-ahead-container">
          <ConnectionsTagsTypeAhead
            {...this.props}
            tags={this.props.allUserTags}
          />
        </div>
      </ClickAwayListener>
    );
  },
});

export default ConnectionsTypeAhead;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-tags-modal/connections-tags-typeahead/typeahead-container.jsx